import { professional, dataAuditReport, facility, ancillary } from './other';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = (permissions) => {
  const userType = localStorage.getItem('userType');
  const {
    allDataAuditReportPermission,
    hasDataAuditReportModulePermision,
    hasProfessionalModulePermission,
    allProfessionalPermission,
    hasAncillaryModulePermission,
    hasFacilityModulePermission,
    allAncillaryPermission,
    allFacilityPermission
  } = permissions;

  const menuItems = [];
  if (hasProfessionalModulePermission && userType === 'professional') {
    menuItems.push(professional(allProfessionalPermission));
  }

  if (hasDataAuditReportModulePermision && userType === 'dataAuditReport') {
    menuItems.push(dataAuditReport(allDataAuditReportPermission));
  }

  if (hasAncillaryModulePermission && userType === 'ancillary') {
    menuItems.push(ancillary(allAncillaryPermission));
  }
  if (hasFacilityModulePermission && userType === 'facility') {
    menuItems.push(facility(allFacilityPermission));
  }

  return {
    items: menuItems
  };
};

export default menuItems;
